var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg476Dab3B4F69C5886Bdab2C64C134F28E20F00(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e20f00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 4C12.96 4 4 12.95 4 24s8.96 20 20 20 20-8.95 20-20S35.04 4 24 4zm2 30h-4v-4h4v4zm0-8h-4V14h4v12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg476Dab3B4F69C5886Bdab2C64C134F28E20F00);
export default __webpack_public_path__ + "static/media/476dab3b4f69c5886bdab2c64c134f28_e20f00.0af905229b18fa80c1cb7a91aefc8fb2.svg";
export { ForwardRef as ReactComponent };